import { Divider, Flex, HStack, VStack } from "@chakra-ui/react";
import { ShowName } from "features/Resources/Shared/Components/Fields/NameField";
import { ShowRichText } from "components/FormElements/Fields/RichTextAreaField";
import { ActionTypeTag } from "design-system";
import { ShowRelativeDateTime } from "features/Resources/Shared/Components/Fields/DateTimeZoneField.tsx/HorizontalDateTimeZoneField";
import ResourceOptionMenu from "features/Resources/Shared/Components/Button/ResourceOptionMenu";
import { Meeting } from "../models";
import { ShowMeetingStatus } from "../Components/MeetingStatus";
import { ShowAttendees } from "../Components/DisplayAttendees";

interface PastMeetingProps {
  meeting: Meeting;
  includeHeader?: boolean;
  includeStatus?: boolean;
}

export default function PastMeeting({ meeting, includeHeader = true, includeStatus = true }: PastMeetingProps) {
  const dateLabel = "Scheduled At";
  const dateValue = meeting?.scheduledAt;
  const statusDateLabel = "";
  return (
    <VStack spacing={4} align="stretch" width="100%">
      <Flex w="100%" justify="space-between">
        {includeHeader && (
          <HStack align="center" height="40px">
            <ActionTypeTag.MeetingBadge />
            <ShowName name={meeting?.name} />
          </HStack>
        )}
        {meeting && meeting.status !== "completed" && <ResourceOptionMenu prefixId={meeting?.prefixId} />}
      </Flex>
      {includeStatus && <ShowMeetingStatus meeting={meeting} />}
      <ShowAttendees attendees={meeting.attendees} label="Attendees" />
      <ShowRelativeDateTime label={dateLabel} date={dateValue} timezone={meeting?.timezone} />
      {statusDateLabel && <ShowRelativeDateTime label={statusDateLabel} date={meeting?.statusUpdatedAt} timezone={meeting?.timezone} />}
      <Divider my="4" />
      {["group_session_adhoc", "group_session_recurring"].includes(meeting.meetingType) ? (
        <ShowRichText label="Learning Objective" richText={meeting.learningObjective as string} />
      ) : (
        <ShowRichText label="Purpose" richText={meeting.purpose as string} />
      )}
      <ShowRichText label="Additional Info" richText={meeting.additionalInfo as string} />
    </VStack>
  );
}
